module.exports = __webpack_public_path__ + "img/dcmm_21.8ba6694e.png";